import { APP_STYLE_CONFIG } from '@/constants';
import { CARD_LABELS } from '@/constants/labels';
import { Card, ICardAction } from '@/components/Cards';

/** Props for the RetakeRoleplayCard component */
interface RetakeRoleplayCardProps {
  /** The title of the card */
  cardTitle?: string;
  /** The title of the next simulation */
  nextSimulationTitle?: string;
  /** Actions available for retaking the roleplay */
  retakeRoleplayActions: ICardAction[];
  /** Whether to show a border around the card */
  showCardBorder?: boolean;
  /** Whether to show a border around the card content */
  showCardContentBorder?: boolean;
}

/**
 * Component for displaying a card that allows users to retake a roleplay simulation.
 * It shows the title of the next simulation and provides actions for retaking the roleplay.
 */
export const RetakeRoleplayCard: React.FC<RetakeRoleplayCardProps> = ({
  cardTitle = CARD_LABELS.NEXT_ROLEPLAY,
  nextSimulationTitle,
  retakeRoleplayActions,
  showCardBorder = APP_STYLE_CONFIG.showCardBorder,
  showCardContentBorder = APP_STYLE_CONFIG.showCardContentBorder,
}) => {
  return (
    <Card
      actions={retakeRoleplayActions}
      subtitle={nextSimulationTitle}
      title={cardTitle}
      withBorder={showCardBorder}
      withContentBorder={showCardContentBorder}
    />
  );
};

RetakeRoleplayCard.displayName = 'RetakeRoleplayCard';

export default RetakeRoleplayCard;
